'use es6';

function postMessageMiddleware(eventBus) {
  return () => next => action => {
    if (!action.source) {
      action.source = 'iframe';
    }
    if (eventBus && !action.iframeOnly && action.source !== 'app') {
      const promise = eventBus.postMessage(Object.assign({
        action: 'reduxAction',
        source: 'redux'
      }, action));
      const result = next(action);
      if (action.needsResponse) {
        return promise.then(() => result);
      }
      return result;
    }
    return next(action);
  };
}
export default postMessageMiddleware;